/** SVG path data for an elevation profile in a W×H box. */
export function profilePath(
  points: { d: number; ele: number }[],
  w: number,
  h: number,
): { line: string; area: string; min: number; max: number } {
  if (points.length < 2) return { line: "", area: "", min: 0, max: 0 };
  const total = (points[points.length - 1] as { d: number }).d || 1;
  let min = Infinity;
  let max = -Infinity;
  for (const p of points) {
    min = Math.min(min, p.ele);
    max = Math.max(max, p.ele);
  }
  // Keep at least 20 m of vertical range so flat runs look flat.
  const span = Math.max(20, max - min);
  const mid = (max + min) / 2;
  const lo = mid - span / 2;
  const pad = 4;
  const xy = points.map(
    (p) => [(p.d / total) * w, h - pad - ((p.ele - lo) / span) * (h - 2 * pad)] as const,
  );
  const line = xy.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`).join("");
  return { line, area: `${line}L${w},${h}L0,${h}Z`, min, max };
}
